<script >
import MyTable from '../../components/MyTable.vue';
import { reactive, onMounted, ref, inject, watch } from 'vue'
import moment from "moment";
import { useRouter, useRoute } from 'vue-router'
export default {
  components: {
    MyTable
  },
  setup () {
    const router = useRouter()
    const route = useRoute()

    const state = reactive({
      historicoPagamento: [
        { payment_reference: '06/2024', payment_date: '2024-06-24', payment_amount: '21990', payment_form: 'Crédito à vista', plan: 'Plano PRO Anual'  }
      ]
    })

    const columns = ref([
      {
        label: 'Mês referência',
        field: 'payment_reference',
        sortable: 'payment_reference'
      },
      {
        label: 'Data do pagamento',
        field: 'payment_date',
        sortable: 'payment_date'
      },
      {
        label: 'Valor pago',
        field: 'payment_amount',
        sortable: 'payment_amount'
      },
      {
        label: 'Plano',
        field: 'payment_form',
        sortable: 'payment_form'
      }
    ])

    function voltar() {
      router.back()
    }

    return {
      state,
      columns,
      voltar
    }
  }
}
</script>

<template>
  <div class="bg-white card border-radius-xl me-3"
       data-animation="FadeIn">
    <div class="card-body">
      <div class="row">
        <div class="col-12 mb-2">
          <h4>
            Marcos Antônio
          </h4>
        </div>
        <div class="col-12 me-2">
          <h5>
            Acesso liberado até 24/06/2025
          </h5>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-12">
          <h5>
            Histórico de pagamentos
          </h5>
        </div>
      </div>
      <MyTable
          :searchable="false"
          :data="state.historicoPagamento"
          :columns="columns"
          :itemsPerPage="12">
        <template v-slot:row="{ row }">
          <td class="text-sm ">
            {{ row.payment_reference }}
          </td>
          <td class="text-sm ">
            {{ $filters.datePtbr(row.payment_date) }}
          </td>
          <td class="text-sm ">
            {{ $filters.converteCentavosValor(row.payment_amount) }} <br>
            <span class="small">{{ row.payment_form }}</span>
          </td>
          <td class="text-sm ">
            {{ row.plan }}
          </td>

        </template>
      </MyTable>
      <div class="row mt-5">
        <div class="col-12 text-end">
          <button type="button" class="btn btn-secondary" @click.prevent="voltar">
            Voltar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>